import { Observable, map } from "rxjs";
import { ISessionStateService } from "./i-session-state.service";
import { roleAtLeast, TCompanyRole } from "../../models/company-role";

/** Whether the current user's role in the active company reaches `minimum`, for hiding what the backend refuses. */
export function roleAtLeast$( sessionStateService: ISessionStateService, minimum: TCompanyRole ): Observable<boolean> {
	return sessionStateService.activeRole$.pipe( map( role => roleAtLeast( role, minimum ) ) );
}
